import { withStyles, Box } from '@material-ui/core';

export const IconWrapper = withStyles(() => ({
  root: {
    position: 'absolute',
    top: '50%',
    right: 20,
    transform: `translate(0, -50%)`,
  },
}))(Box);
